import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "@/lib/auth";

export default function RequireAdmin({ children }) {
  const token = getToken();
  const loc = useLocation();
  if (!token) {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }
  return children;
}
